type JSXString = string | JSX.Element;

type Props = {
  children: JSXString[] | JSXString;
};

export const AuthSubTitle = ({ children }: Props) => (
  <p className="mt-1 text-sm text-gray-600 text-center max-w-sm m-auto">{children}</p>
);
